module.exports = __webpack_public_path__ + "img/86a75a825a93f384f700baa9416b9dc9.png";